import { Button, Flex, Select } from '@chakra-ui/react';
import Input from '../../components/Input';

export function FiltroPedido({ register, handleSubmit, isLoading }) {
  return (
    <Flex
      w="100%"
      p={4}
      justifyContent="center"
      alignItems="flex-end"
      gap={2}
      maxW="1200px"
      mx="auto"
      as="form"
      onSubmit={handleSubmit}>
      <Input type="date" label="Data de saída de:" {...register('dataInicio')} />
      <Input type="date" label="até:" {...register('dataFim')} />
      <Input label="Pedido" type="text" {...register('numeroPedido')} />
      <Select placeholder="Status da Entrega" {...register('statusEntrega')} defaultValue="5">
        <option value="0">Todos</option>
        <option value="1">Entregue</option>
        <option value="5">Não entregue</option>
        <option value="2">Coletado</option>
        <option value="3">Arquivo Importado</option>
        <option value="4">Setor de Devolução</option>
      </Select>
      <Button
        type="submit"
        colorScheme="blue"
        maxW="200px"
        w="100%"
        isLoading={isLoading}
        loadingText="Buscando...">
        Buscar
      </Button>
    </Flex>
  );
}
